var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { arcgisImport } from '../../ArcgisMapCdn';
import defaultSymbol from '../../assets/defaultSymbol.svg';
import { formatCoordinatesToString } from './formatCoordinates';
export const defaultCoordinates = '-118.80500,34.02700';
/**
 * Creates a picture marker symbol for ArcGIS.
 *
 * @param {string} [url] - Optional URL of the marker image. Defaults to the `defaultSymbol` constant if not provided.
 * @param {number} [width=36] - Width of the marker in pixels.
 * @param {number} [height=47] - Height of the marker in pixels.
 * @returns {{url: string, type: string, width: number, height: number, yoffset: number}} The ArcGIS picture marker symbol configuration.
 */
export const markerSymbol = (url, width = 36, height = 47) => {
    return {
        url: url !== null && url !== void 0 ? url : defaultSymbol,
        type: 'picture-marker',
        width: width,
        height: height,
        yoffset: height / 2,
    };
};
/**
 * Creates a point graphic in ArcGIS.
 *
 * @param {Point} point - The geographic point where the marker should be placed.
 * @param {GraphicSymbol} markerSymbol - The symbol configuration for the point marker.
 * @returns {Promise<any>} A promise resolving to the created ArcGIS Graphic object.
 */
export const createPoint = (point, markerSymbol) => __awaiter(void 0, void 0, void 0, function* () {
    const Graphic = yield arcgisImport('esri/Graphic');
    return new Graphic({
        geometry: point,
        symbol: markerSymbol,
    });
});
/**
 * Adds a location tracking button to an ArcGIS view.
 *
 * @param {any} view - The ArcGIS map view instance.
 * @param {(coordinates: string) => void} handleValueChange - Callback to handle updated coordinates from location tracking.
 * @returns {Promise<void>} A promise that resolves once the location button has been added.
 */
export const addLocationButton = (view, handleValueChange) => __awaiter(void 0, void 0, void 0, function* () {
    const Track = yield arcgisImport('esri/widgets/Track');
    const track = new Track({
        view: view,
        graphic: undefined,
        useHeadingEnabled: false,
    });
    track.on('track', (evt) => {
        const { longitude, latitude } = evt.position.coords;
        handleValueChange(formatCoordinatesToString(latitude, longitude));
    });
    view.ui.add(track, 'top-left');
});
